import React, { useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import { Modal } from '../../../components';
import PostsSectionForm from './PostsSectionForm';
import { axiosApi, handleAxiosResponse } from '../../../util/axiosApi';
import { getDescriptionKeywords, getPostsKeywords } from '../../../util/editListing';
import News from './News';
import Content from './Content';
import Events from './Events';

import css from './PostsSection.module.scss';

const getKeywords = (listing, news, content, events) => {
  return uniq([
    ...getDescriptionKeywords(
      get(listing, 'attributes.title', []),
      get(listing, 'attributes.description', []),
      get(listing, 'attributes.publicData.category', []),
      get(listing, 'attributes.publicData.subcategory', []),
      get(listing, 'attributes.publicData.differentiationFromCompetitors', []),
    ),
    ...getPostsKeywords(news, content, events),
  ]);
};

const PostsSection = props => {

  const {
    publicData,
    isOwnListing,
    onManageDisableScrolling,
    onUpdateListing,
    onLoadData,
    id,
    slug,
    isPreview,
    intl,
    listing
  } = props

  const news = publicData?.news;
  const content = publicData?.content;
  const events = publicData?.events;

  if ((!news || news?.length < 1) && (!content || content?.length < 1) && (!events || events?.length < 1)) {
    return null;
  }

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [postIndex, setPostIndex] = useState(null);
  const [postType, setPostType] = useState(null);
  const [inProgress, setInProgress] = useState(false);

  const handleEditPopup = (editPopupStatus, deletePopupStatus, type, index) => {
    setShowEditPopup(editPopupStatus);
    setShowDeletePopup(deletePopupStatus);
    setPostIndex(index);
    setPostType(type);
  }

  const handleEditPost = async (values) => {

    setInProgress(true)

    let data = {
      id,
      publicData: {}
    };

    let imageLink = values?.link;

    const getLinkPreview = async () => {
      if (!values?.link) {
        imageLink = values?.link;
      } else {
        await axiosApi.get(`/link-preview?link=${values.link}`)
          .then(handleAxiosResponse)
          .then(data => {
            const imageUrl = get(data, 'imgUrl', values.link);
            imageLink = imageUrl
          })
          .catch(e => {
            imageLink = null
          });
      }
    };
    await getLinkPreview();

    const updatedPostContent = (values, postsArray) =>
      postsArray.map((p, index) => index == postIndex ? values : p)

    let updatedNews = postType === "news" && updatedPostContent(values, news) || [];
    let updatedContent = postType === "content" && updatedPostContent(values, content) || [];
    let updatedEvents = postType === "events" && updatedPostContent(values, events) || [];

    updatedNews.map((item, index) => {
      if (index === postIndex) {
        item.image.url = imageLink;
      }
      return item
    })

    updatedContent.map((item, index) => {
      if (index === postIndex) {
        item.image.url = imageLink;
      }
      return item
    })

    updatedEvents.map((item, index) => {
      if (index === postIndex) {
        item.image.url = imageLink;
      }
      return item
    })

    if (postType === "news") {
      data.publicData = { news: !!updatedNews?.length ? updatedNews : news }
    }
    if (postType === "content") {
      data.publicData = { content: updatedContent?.length ? updatedContent : content }
    }
    if (postType === "events") {
      data.publicData = { events: updatedEvents?.length ? updatedEvents : events }
    }

    data.publicData.keywords = getKeywords(
      listing,
      !!updatedNews?.length ? updatedNews : news,
      updatedContent?.length ? updatedContent : content,
      updatedEvents?.length ? updatedEvents : events
    );

    return onUpdateListing('posts', data)
      .then(resp => {
        onLoadData({ id, slug })
        return resp
      })
      .then(resp => {
        setInProgress(false)
        setShowEditPopup(false);
        return resp
      })
      .catch(e => console.log(e));
  }

  const handleDeletePost = () => {
    let data = {
      id,
      publicData: {}
    };

    const updatedPostContent = postsArray =>
      postsArray?.filter((item, index) => index !== postIndex)

    const updatedNews = postType === "news" && updatedPostContent(news);
    const updatedContent = postType === "content" && updatedPostContent(content);
    const updatedEvents = postType === "events" && updatedPostContent(events);

    if (postType === "news") {
      data.publicData = { news: !!updatedNews?.length ? updatedNews : null }
    }
    if (postType === "content") {
      data.publicData = { content: updatedContent?.length ? updatedContent : null }
    }
    if (postType === "events") {
      data.publicData = { events: updatedEvents?.length ? updatedEvents : null }
    }

    data.publicData.keywords = getKeywords(
      listing,
      !!updatedNews?.length ? updatedNews : news,
      updatedContent?.length ? updatedContent : content,
      updatedEvents?.length ? updatedEvents : events
    );

    return onUpdateListing('posts', data)
      .then(resp => {
        onLoadData({ id, slug })
        setShowDeletePopup(false);
        return resp
      })
      .catch(e => console.log(e));
  }

  let initialValues =
    postType === "news" ? news?.[postIndex] :
      postType === "content" ? content?.[postIndex] :
        postType === "events" ? events?.[postIndex] : [];

  return (
    <>
      <News
        news={news}
        handleEditPopup={handleEditPopup}
        isOwnListing={isOwnListing}
        isPreview={isPreview}
        intl={intl}
        />
      <Content
        content={content}
        handleEditPopup={handleEditPopup}
        isOwnListing={isOwnListing}
        isPreview={isPreview}
        intl={intl}
      />
      <Events
        events={events}
        handleEditPopup={handleEditPopup}
        isOwnListing={isOwnListing}
        isPreview={isPreview}
        intl={intl}
      />

      <Modal
        id="PostsSection.editPopup"
        isOpen={showEditPopup}
        onClose={() => handleEditPopup(false, null, null)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <PostsSectionForm
          initialValues={initialValues}
          onSubmit={handleEditPost}
          inProgress={inProgress}
          postType={postType}
        />
      </Modal>

      <Modal
        id="PostsSection.deletePopup"
        contentClassName={css.removePostContent}
        isOpen={showDeletePopup}
        onClose={() => setShowDeletePopup(false)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <p className={css.removePostDescription}>
          <FormattedMessage id="ListingPage.removePostDescription" />
        </p>

        <div className={css.removePostButtons}>
          <span
            className={css.removePostButton}
            onClick={() => setShowDeletePopup(false)}
          >
            <FormattedMessage id="ListingPage.removeNo" />
          </span>
          <span
            className={css.removePostButton}
            onClick={() => handleDeletePost()}
          >
            <FormattedMessage id="ListingPage.removeYes" />
          </span>
        </div>
      </Modal>
    </>
  );
};

export default PostsSection;
